import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HttpModule } from "@angular/http";
import { HttpClientModule } from "@angular/common/http";
import { LocationStrategy, HashLocationStrategy } from '@angular/common';

/**
 * Configurations
 */
import { Configuration } from "./configuration/app.constants";


/**
 * Components
 */
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './partials/footer/footer.component';
import { SidenavComponent } from './partials/sidenav/sidenav.component';
import { NavbarComponent } from './partials/navbar/navbar.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { ContactsComponent } from './pages/contacts/contacts/contacts.component';
import { DataTablesModule } from 'angular-datatables';
import { AddcontactsComponent } from './pages/contacts/addcontacts/addcontacts.component';
import { ReceiptsComponent } from "./pages/receipts/receipts/receipts.component";
import { AddreceiptsComponent } from './pages/receipts/addreceipts/addreceipts.component';
import { AddClientContactComponent } from './pages/contacts/addClientContact/add-client-contact.component';
import { MainPageComponent } from './POC/main-page/main-page.component';
import { PrintPageComponent } from './POC/print-page/print-page.component';
import { SearchDetaiesComponent } from './pages/search/search-detaies/search-detaies.component';
import { EventPrintLabelComponent } from './pages/search/event-print-label/event-print-label.component';
import { GenerateReceiptsComponent } from './pages/receipts/generate-receipts/generate-receipts.component';
import { GeneratePrintReceiptsComponent } from './pages/receipts/generate-print-receipts/generate-print-receipts.component';
import { MagazineComponent } from './pages/magazine/magazine/magazine.component';
import { LoginComponent } from './pages/auth/login/login.component';
import { TextDecerationPipe } from './pipe/textDeceration/text-deceration.pipe';
import { DonationComponent } from './pages/donation/donation/donation.component';


/**
 * Services
 */
import { AuthGuardService } from "./services/auth/authGuard/auth-guard.service";

/**
 * Added models
 */
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { NgDatepickerModule } from 'ng2-datepicker';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { Angular2CsvModule } from 'angular2-csv';
import { CreateNewPartnerIDComponent } from './partials/modal/create-new-partner-id/create-new-partner-id.component';
import { DonationListComponent } from './pages/donation/donation-list/donation-list.component';
import { PrintReceiptComponent } from './pages/receipts/print-receipt/print-receipt.component';
import { ReceiptDetailsComponent } from './partials/modal/receipt-details/receipt-details.component';
import { DonationDetailsComponent } from './partials/modal/donation-details/donation-details.component';
import { VerifyDonationComponent } from './partials/modal/verify-donation/verify-donation.component';
import { ContactListComponent } from './pages/contacts/contactList/contact-list.component';
import { ContactDetailsComponent } from './partials/modal/contact-details/contact-details.component';
import { MagazineDetailsComponent } from './partials/modal/magazine-details/magazine-details.component';
import { DuplicatePartnerMappingComponent } from './pages/contacts/duplicate-partner-mapping/duplicate-partner-mapping.component';
import { EventListComponent } from './pages/events/event-list/event-list.component';
import { EventRegiserDetailsComponent } from './partials/modal/event-regiser-details/event-regiser-details.component';
import { EventRegiserStatusComponent } from './partials/modal/event-regiser-status/event-regiser-status.component';
import { XlxsDownloadComponent } from './POC/xlxs-download/xlxs-download.component';
import { PrintLetterComponent } from './pages/receipts/print-letter/print-letter.component';
import { AgePipe } from './pipe/getAge/age.pipe';
import { EventRegistrationComponent } from './pages/events/event-registration/event-registration.component';
import { BuildDetailsHttpService } from './version-check/build-details.http.service';
import { UpToDateComponent } from './version-check/up-to-date.component';
import { EventsContactListComponent } from './pages/events/events-contact-list/events-contact-list.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CreateNewPartnerIDInEventComponent } from './partials/modal/create-new-partner-idin-event/create-new-partner-idin-event.component';
import { RemoveSplCharPipe } from './pipe/removeSplChar/remove-spl-char.pipe';
import { EditCreateNewPartnerIdinEventComponent } from './partials/modal/edit-create-new-partner-idin-event/edit-create-new-partner-idin-event.component';
import { RoomApprovalComponent } from './partials/modal/room-approval/room-approval.component';
import { PdfReceiptComponent } from './pages/receipts/pdf-receipt/pdf-receipt.component';

export function fetchBuildDetails(buildDetailsService: BuildDetailsHttpService) {
  return () => buildDetailsService.fetchBuildDetails();
}
@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    SidenavComponent,
    NavbarComponent,
    DashboardComponent,
    ContactsComponent,
    AddcontactsComponent,
    ReceiptsComponent,
    AddreceiptsComponent,
    AddClientContactComponent,
    MainPageComponent,
    PrintPageComponent,
    SearchDetaiesComponent,
    EventPrintLabelComponent,
    GenerateReceiptsComponent,
    GeneratePrintReceiptsComponent,
    MagazineComponent,
    LoginComponent,
    TextDecerationPipe,
    DonationComponent,
    CreateNewPartnerIDComponent,
    DonationListComponent,
    PrintReceiptComponent,
    ReceiptDetailsComponent,
    DonationDetailsComponent,
    VerifyDonationComponent,
    ContactListComponent,
    ContactDetailsComponent,
    MagazineDetailsComponent,
    DuplicatePartnerMappingComponent,
    EventListComponent,
    EventRegiserDetailsComponent,
    EventRegiserStatusComponent,
    XlxsDownloadComponent,
    PrintLetterComponent,
    AgePipe,
    RemoveSplCharPipe,
    EventRegistrationComponent,
    UpToDateComponent,
    EventsContactListComponent,
    CreateNewPartnerIDInEventComponent,
    EditCreateNewPartnerIdinEventComponent,
    RoomApprovalComponent,
    PdfReceiptComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    DataTablesModule,
    HttpModule,
    HttpClientModule,
    AutocompleteLibModule,
    NgDatepickerModule,
    AngularFontAwesomeModule,
    NgxSkeletonLoaderModule,
    Angular2CsvModule,
    ReactiveFormsModule
  ],

  providers: [
    { provide: APP_INITIALIZER, useFactory: fetchBuildDetails, deps: [BuildDetailsHttpService], multi: true },
    { provide: LocationStrategy, useClass: HashLocationStrategy }, Configuration, EventPrintLabelComponent, AuthGuardService
    // GetContactInfoService, GetselectedContactInfoService,
    // GetOfferingTypeService, GetEventService, GetEventPaymentService,
    // GetBankService, GetDraweeBankService, GetAmbassadorInfoService, KeyMapService, AddNewReceiptService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
